import { Entity, Identifier, Serializer } from 'ddd-base';

export class SSOParamsIdentifier extends Identifier<string> {}

const id = new SSOParamsIdentifier('ssoParams');

export const SSOParamsConverter: Serializer<SSOParams, SSOParamsJSON> = {
    fromJSON(json) {
        return new SSOParams({
            id,
            origin: json.origin,
        });
    },
    toJSON(entity: SSOParams): SSOParamsJSON {
        return {
            id: entity.id.toValue(),
            origin: entity.origin,
        };
    },
};

export const createSSOParams = () => {
    return new SSOParams({
        id,
    });
};

export interface SSOParamsJSON {
    readonly id?: string;
    readonly origin?: string;
    readonly close?: boolean;
}

export interface SSOParamsProps {
    readonly id: SSOParamsIdentifier;
    readonly origin?: string;
    readonly close?: boolean;
}

export class SSOParams extends Entity<SSOParamsProps> implements SSOParamsProps {
    readonly id: SSOParamsIdentifier;
    readonly origin?: string;
    readonly close?: boolean;

    constructor(props: SSOParamsProps) {
        super(props);
        this.id = props.id;
        this.origin = props.origin;
        this.close = props.close;
    }

    hasOrigin(): boolean {
        return !!this.origin;
    }

    updateOrigin(origin: string) {
        return new SSOParams({
            ...this.props,
            origin,
        });
    }
}
